export default __webpack_public_path__ + "static/media/speedoMeter.5f0d12f0.svg";